<template>
  <Page :breadCrumb="breadCrumb" class="blank-page">
    欢迎来到兔兔出国
  </Page>
</template>
<script>
import Page from '@/components/Page'

export default {
  components: {
    Page,
    
  },
  data() {
    return {
      
    }
  },
  methods: {
    breadCrumb() {
      return ['首页']
    },
  },
}
</script>
<style lang="less" scoped>

</style>
